// extracted by mini-css-extract-plugin
export default {"productDescription":"kaa-z","featuredDescription":"laa-z","description":"maa-z","more":"naa-z","descriptionSku":"oaa-z"};